const prefix = 'admin';

export const login = `${prefix}/login`;
